import { TagManagerArgs } from '@legalshield/frontend-analytics';
import { Environment } from '@legalshield/legalshield-member-react-common';

const getGtmVars = (): TagManagerArgs => {
  const host = window.location.hostname;
  if (host.includes('dev-') || host.includes('localhost')) {
    return {
      auth: '8ORNwoYVVPtSAsoW7UGgKw',
      gtmId: 'GTM-NQ3J2B7',
      preview: 'env-17',
    };
  } else if (host.includes('uat-')) {
    return {
      auth: '5B6USoiYGGAjfirnUbMYCw',
      gtmId: 'GTM-NQ3J2B7',
      preview: 'env-21',
    };
  } else {
    return {
      auth: 'g_gdq8mpXSg8PHfXMX3lQ',
      gtmId: 'GTM-NQ3J2B7',
      preview: 'env-1',
    };
  }
};

// Launch Darkly Project `products-benefits-web`
const launchDarklyConfig: Record<Environment, { clientSideID: string }> = {
  [Environment.Dev]: {
    clientSideID: '68af41fb50008e0aee910e3f',
  },
  [Environment.Local]: {
    clientSideID: '68af41fb50008e0aee910e3f',
  },
  [Environment.Uat]: {
    clientSideID: '68af421c49bac50ab7840b33',
  },
  [Environment.Prod]: {
    clientSideID: '68af422f3fe17c0ab5babc4a',
  },
};

const getEnvironment = (): Environment => {
  const host = window.location.hostname;
  if (host.includes('dev-')) {
    return Environment.Dev;
  } else if (host.includes('localhost')) {
    return Environment.Local;
  } else if (host.includes('uat-')) {
    return Environment.Uat;
  } else {
    return Environment.Prod;
  }
};

export default {
  getEnvironment,
  getGtmVars,
  launchDarklyConfig: launchDarklyConfig[getEnvironment()],
};
